import { render, staticRenderFns } from "./list.vue?vue&type=template&id=3b027d21&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b027d21')) {
      api.createRecord('3b027d21', component.options)
    } else {
      api.reload('3b027d21', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=3b027d21&", function () {
      api.rerender('3b027d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lowstock/list.vue"
export default component.exports